var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70973 5.74101H7.99408V11.6206C7.99408 11.697 8.05665 11.7596 8.13312 11.7596H9.1759C9.25237 11.7596 9.31494 11.697 9.31494 11.6206V5.74101H10.6028C10.7192 5.74101 10.7835 5.60718 10.7123 5.51681L8.76574 3.05237C8.75274 3.03575 8.73612 3.02231 8.71715 3.01307C8.69818 3.00383 8.67735 2.99902 8.65625 2.99902C8.63515 2.99902 8.61432 3.00383 8.59535 3.01307C8.57638 3.02231 8.55976 3.03575 8.54676 3.05237L6.60023 5.51507C6.52898 5.60718 6.59328 5.74101 6.70973 5.74101V5.74101ZM15.0172 11.0992H13.9744C13.898 11.0992 13.8354 11.1617 13.8354 11.2382V13.9147H3.47711V11.2382C3.47711 11.1617 3.41454 11.0992 3.33807 11.0992H2.29529C2.21882 11.0992 2.15625 11.1617 2.15625 11.2382V14.6794C2.15625 14.987 2.40478 15.2355 2.7124 15.2355H14.6001C14.9077 15.2355 15.1562 14.987 15.1562 14.6794V11.2382C15.1562 11.1617 15.0937 11.0992 15.0172 11.0992Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic-upload.6c26bb20d83c7e78a12e04fb914c746d.svg";
export { ForwardRef as ReactComponent };